import { Breadcrumbs } from "../Navigation/Breadcrumbs";

export function PageHeading({ title, withBreadcrumbs, subtitle }) {
  return (
    <div className="mb-6">
      {withBreadcrumbs && <Breadcrumbs className="mb-2" />}

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div className="flex-1 min-w-0">
          <h1 className="text-3xl sm:text-4xl font-semibold text-gray-900 leading-snug sm:truncate">
            {title}
          </h1>

          {subtitle && (
            <p className="mt-1 text-gray-500 text-sm sm:text-base">
              {subtitle}
            </p>
          )}
        </div>

        {/* Optional action buttons */}
        {/* <div className="mt-3 sm:mt-0 flex gap-2">
          <Button primary>New Order</Button>
        </div> */}
      </div>

      {/* subtle accent line */}
      <div className="mt-4 h-0.5 w-16 rounded-full bg-blue-500" />
    </div>
  );
}